export function requireModule(modulePath, type) {
  const path = `${modulePath}${type === "pages" ? "/routes.js" : ""}`;
  try {
    return require(`@/modules/${path}`).default;
  } catch {
    // console.error(`${modulePath} : ${type} not found on ${path}`);
  }
}
